// extracted by mini-css-extract-plugin
export default {"content":"t1_content__SLVIn","side":"t1_side__6hx-4","main":"t1_main__Cub2v","block":"t1_block__OuMPQ","duration":"t1_duration__3-hhJ","bluff":"t1_bluff__pi6Dt"};